import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronIcon } from './icons/Icons';
export const FAQ = () => {
  const faqs = [{
    q: '¿Es seguro para mi tipo de piel?',
    a: 'Antes de cualquier tratamiento hacemos una evaluación personalizada. Nunca aplicamos nada sin entender primero TU piel específica.'
  }, {
    q: '¿Ya probé cosas y no funcionaron?',
    a: 'La diferencia está en el diagnóstico correcto. Un producto genérico nunca va a reemplazar un protocolo diseñado para ti.'
  }, {
    q: '¿Duele?',
    a: 'La mayoría de nuestros tratamientos son sumamente cómodos. Los que involucran agujas o láser cuentan con preparación previa para minimizar cualquier incomodidad.'
  }, {
    q: '¿Cuántas sesiones necesito?',
    a: 'Depende de tu piel y tu objetivo. Muchas clientas notan cambios desde la primera sesión. Te explicamos exactamente qué esperar en tu consulta inicial.'
  }, {
    q: '¿Es caro?',
    a: 'Considera cuánto has gastado en productos que no funcionaron. Una inversión en el tratamiento correcto es infinitamente más eficiente. Hablamos de opciones en tu consulta.'
  }, {
    q: '¿Qué hace diferente a Fernanda?',
    a: 'Fernanda es Esthetician Y Medical Assistant — doble formación que garantiza tanto la estética como la seguridad en cada procedimiento.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section id="faq" className="py-12 md:py-16 bg-brand-cream relative" data-id="element-84">
      <div className="container mx-auto px-6 max-w-3xl" data-id="element-85">
        <div className="text-center mb-8 md:mb-10" data-id="element-86">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-charcoal mb-3" data-id="element-87">
            Preguntas Frecuentes
          </h2>
          <p className="text-xl text-brand-bronze font-serif italic" data-id="element-88">
            Resolvemos tus dudas con transparencia
          </p>
        </div>

        <div className="space-y-4" data-id="element-89">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: idx * 0.1
        }} className="border border-brand-gold/20 rounded-xl bg-white overflow-hidden shadow-sm" data-id="element-90">
              <button onClick={() => toggleFAQ(idx)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === idx} data-id="element-91">
                <span className="text-lg font-medium text-brand-charcoal pr-4" data-id="element-92">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === idx ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="text-brand-gold flex-shrink-0" data-id="element-93">
                  <ChevronIcon size={20} data-id="element-94" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-95">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-96">
                    <div className="px-6 pb-6 pt-2 text-brand-charcoal/70 leading-relaxed border-t border-brand-cream mx-6" data-id="element-97">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
};